/**
 * What the bell badge shows for a count.
 *
 * Capped at "99+": past that the exact number is noise, and three or four digits overflow the
 * badge's fixed height. The screen-reader label keeps the exact count — only the visual is capped.
 */
export const BADGE_MAX = 99;

export function badgeLabel(count: number): string {
  return count > BADGE_MAX ? `${BADGE_MAX}+` : String(count);
}
